
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: Number,
      required: false,
      default: 0
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const onInput = async (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (!input.value || input.value === "") {
        emit("update:modelValue", parseInt(input.value));
        return;
      }

      emit("update:modelValue", parseInt(input.value));
    };

    return { onInput };
  }
});
